import { $IdentityResource } from 'app/resources';
import { Application, ISubscription } from 'app/classes';
import { assign } from 'lodash';

export interface IIdentityApplication {
    application: any;
    status: string;
}

export class IdentityService {

    /**
     * Returns the current user object from identity
     * @returns Promise
     */
    public static getMe() {
        return $IdentityResource.get('users/me/');
    }

    /**
     * Returns the org of the current user
     * @param  {String} orgId
     */
    public static getCurrentOrg(orgId: string) {
        return $IdentityResource.get(`v2/organizations/${orgId}/`);
    }

    /**
     * Returns the subscribed apps of the current user's org
     * @param  {String} orgId
     */
    public static getSubscribedApps() {
        return $IdentityResource.get('users/me/subscriptions/').then((resp) => {
            return resp.results.reduce((accum, obj: ISubscription) => {
                const application = obj.application
                if (application.is_service){
                    return accum;
                }
                return accum.concat(
                    assign(
                        {},
                        application,
                        {
                            subscription: {
                                provisioned_date: obj.provisioned_date,
                                application_id: obj.application_id,
                                organization_id: obj.organization_id,
                                provisioned_user_id: obj.provisioned_user_id,
                                status: obj.status,
                                updated_by_id: obj.updated_by_id,
                                updated_date: obj.updated_date
                            }
                        }
                    )
                );
            }, []);
        });
    }

    /**
     * Checks the validity of the stored token against identity
     * @returns {Promise}
     */
    public static checkToken() {
        return $IdentityResource.get('check/token/');
    }

    /**
     * Deletes the token from Identity, token will no longer be valid.
     * @returns {Promise}
     */
    public static logout() {
        return $IdentityResource.delete('token/');
    }

    /**
     * Sets the authorization headers for identity based on the input token
     * @param {String} token
     */
    public static setToken(token) {
        $IdentityResource.setToken(token);
    }

    public static updateMe(user) {
        return $IdentityResource.put(`v3/users/${user.id}/profile/`, [], user)
            .catch((error) => {
                /* tslint:disable-next-line:no-console */
                console.warn('Unable to save default preferences');
                /* tslint:disable-next-line:no-console */
                console.error(error);
            });
    }
    
    public static updateCommercePlatformTos(userId) {
        const currentDateTime = new Date().toISOString();
        const url = `v3/users/${userId}/profile/`;
        const data = {
            commerce_platform_tos_agreed_at: currentDateTime
        }
        return $IdentityResource.patch(url,[], data);
    }

}
